<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-button
              outline
              color="success"
              @click="translateUnfilledFields"
            >一件翻译绿色Field</va-button>
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.courseId'
              v-show="showId"
              label='唯一标识'
              disabled
            />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.views'
              v-show="showId"
              label='感兴趣人数'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="课程名称"
              :placeholder="placeholders.name"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nameEn"
              label="课程名称(英文)"
              :placeholder="placeholders.nameEn"
              removable
              :messages="message"
              :error="!!error.nameEnErrors.length"
              :error-messages="error.nameEnErrors"
              success
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.projectDuration"
              label="项目时长"
              :placeholder="placeholders.projectDuration"
              removable
              :messages="message"
              :error="!!error.projectDurationErrors.length"
              :error-messages="error.projectDurationErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="课程标签"
              v-model="insertData.courseTagNames"
              multiple
              :options="computedTags"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-select
              label="导师"
              v-model="insertData.mentorUids"
              multiple
              searchable
              :options="computedMentors"
            />
          </div>
          <div class='flex md4 sm6 xs12' v-show="insertData.imgUrl.length!==0">
            <va-card
              overlay
              :image='insertData.imgUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='课程封面图'>
              <va-file-upload
                type='single'
                v-model='insertData.image'
                @input="uploadOnlineActionImage"
              />
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-tree-category isOpen label="你将收获(左边中文, 右边英文)">
              <va-tree-node
                v-for="reward in insertData.willRewards"
                :key="reward.id"
              >
                <div class="flex row align--center">
                  <va-input v-model="reward.reward" :placeholder="placeholders.willReward" removable class="mb-0 flex md5 sm6 xs12"/>
                  <va-input v-model="reward.rewardEn" :placeholder="placeholders.willRewardEn" removable class="mb-0 flex md5 sm6 xs12" success/>
                  <va-icon
                    name="ion ion-md-close"
                    color="info"
                    class="ml-2 pa-1 shrink" d
                    style="cursor: pointer;"
                    @click.native="removeReward(reward)"
                  />
                </div>
              </va-tree-node>
              <va-tree-node>
                <va-button class="mb-2" @click="addReward()">
                  新增收获
                </va-button>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-tree-category isOpen label="学习的技能(左边中文, 右边英文)">
              <va-tree-node
                v-for="skill in insertData.learnedSkills"
                :key="skill.id"
              >
                <div class="flex row align--center">
                  <va-input v-model="skill.skill" :placeholder="placeholders.learnedSkill" removable class="mb-0 flex md5 sm6 xs12"/>
                  <va-input v-model="skill.skillEn" :placeholder="placeholders.learnedSkillEn" removable class="mb-0 flex md5 sm6 xs12" success/>
                  <va-icon
                    name="ion ion-md-close"
                    color="info"
                    class="ml-2 pa-1 shrink" d
                    style="cursor: pointer;"
                    @click.native="removeSkill(skill)"
                  />
                </div>
              </va-tree-node>
              <va-tree-node>
                <va-button class="mb-2" @click="addSkill()">
                  新增学习的技能
                </va-button>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.description"
              :placeholder="placeholders.description"
              type="textarea"
              label="课题介绍"
              maxlength="1024"
              :autosize="true"
              @input="descriptionDescInput"
              removable
              :messages="[message[0] + descriptionRemnantMessage[0]]"
              :error="!!error.descriptionErrors.length"
              :error-messages="error.descriptionErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.descriptionEn"
              :placeholder="placeholders.descriptionEn"
              type="textarea"
              label="课题介绍(英文)"
              maxlength="1024"
              :autosize="true"
              @input="descriptionEnDescInput"
              removable
              :messages="[message[0] + descriptionEnRemnantMessage[0]]"
              :error="!!error.descriptionEnErrors.length"
              :error-messages="error.descriptionEnErrors"
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.intendedFor"
              :placeholder="placeholders.intendedFor"
              label="适用人群"
              removable
              :autosize="true"
              :messages="message"
              :error="!!error.intendedForErrors.length"
              :error-messages="error.intendedForErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.intendedForEn"
              :placeholder="placeholders.intendedForEn"
              label="适用人群(英文)"
              removable
              :autosize="true"
              :messages="message"
              :error="!!error.intendedForEnErrors.length"
              :error-messages="error.intendedForEnErrors"
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.outline"
              :placeholder="placeholders.outline"
              type="textarea"
              label="课程大纲"
              :autosize="true"
              maxlength="1024"
              @input="outlineEnDescInput"
              removable
              :messages="[message[0] + outlineRemantMessage[0]]"
              :error="!!error.outlineErrors.length"
              :error-messages="error.outlineErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.outlineEn"
              :placeholder="placeholders.outlineEn"
              type="textarea"
              label="课程大纲(英文)"
              :autosize="true"
              maxlength="1024"
              @input="outlineDescInput"
              removable
              :messages="[message[0] + outlineEnRemantMessage[0]]"
              :error="!!error.outlineEnErrors.length"
              :error-messages="error.outlineEnErrors"
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-tree-category isOpen label="课程大纲列表">
              <va-tree-node
                v-for="course in insertData.courses"
                :key="course.id"
              >
                <div class="flex row align--center">
                  <div class="flex md1 sm6 xs12">
                    <va-button label="序号"  class="mb-0" outline disabled>{{course.serial}}</va-button>
                  </div>
                  <div class="flex md2 sm6 xs12">
                    <va-input v-model="course.teachingDuration" label="授课周期(小时)" removable class="mb-0" type="number" :min="1" oninput="if(value<0)value=1"/>
                  </div>

                  <div class="flex md4 sm6 xs12">
                    <va-input v-model="course.name" :placeholder="placeholders.course.name" label="标题" removable class="mb-0"/>
                  </div>
                  <div class="flex md5 sm6 xs12">
                    <va-input v-model="course.nameEn" :placeholder="placeholders.course.nameEn" label="标题(英文)" removable class="mb-0" success/>
                  </div>
                  <div class="flex md1 sm6 xs12">

                  </div>
                  <div class="flex md2 sm6 xs12">
                    <va-input v-model="course.learningDuration" label="学习时长(小时)" removable class="mb-0" type="number" :min="1" oninput="if(value<0)value=1"/>
                  </div>
                  <div class="flex md4 sm6 xs12">
                    <va-input v-model="course.inspectionMethod" :placeholder="placeholders.course.inspectionMethod" label="考察方式" removable class="mb-0"/>
                  </div>
                  <div class="flex md4 sm6 xs12">
                    <va-input v-model="course.inspectionMethodEn" :placeholder="placeholders.course.inspectionMethodEn" label="考察方式(英文)" removable class="mb-0" success/>
                  </div>
                  <va-icon
                    name="ion ion-md-close"
                    color="info"
                    class="ml-2 pa-1 shrink"
                    style="cursor: pointer;"
                    @click.native="removeCourse(course)"
                  />
                </div>
              </va-tree-node>
              <va-tree-node>
                <va-button class="mb-2" @click="addCourse()">
                  新增课程
                </va-button>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="状态"
              v-model="insertData.status"
              :options="statusOptions"
              :messages="message"
              :error="!!error.statusErrors.length"
              :error-messages="error.statusErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              type="number"
              :min="1"
              oninput="if(value<1)value=1"
            />
          </div>
          <div class="flex md4 sm6 xs12" v-show="showCreateTime">
            <va-input
              v-model="insertData.createTime"
              label="创建时间"
              disabled
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import onlineActionApi from '../../../api/onlineAction'
import uploadApi from '../../../api/upload'
import { copyObject, formatTime, translateData } from '../../../utils/common'
import mentorApi from '../../../api/mentor'
import { SERVICE_STATUS_TYPES, TAG_TYPE } from '../../../utils/constants'
import tagApi from '../../../api/tag'
import translateApi from '@/api/translate'

export default {
  data () {
    return {
      insertData: {
        id: null,
        courseId: '',
        image: [],
        imgUrl: '',
        name: '',
        nameEn: '',
        intendedFor: '',
        intendedForEn: '',
        projectDuration: '',
        projectDurationEn: '',
        learnedSkills: [],
        willRewards: [],
        description: '',
        descriptionEn: '',
        outline: '',
        outlineEn: '',
        courses: [],
        courseTagNames: [],
        sortNum: 1,
        status: '草稿中',
        views: null,
        mentorUids: [],
        createTime: null,
        creatorUid: '',
      },
      placeholders: {
        name: '例: 活动推荐系统开发',
        nameEn: 'Example: Development of activity recommendation system',
        projectDuration: '例: 12课时',
        description: '例: 此课程不需要预修任何其他课程 软件准备： 集成开发环境下载：Intellij / Eclipse ;数据库下载：MySQL & MongoDB ;工具下载：Postman，Jupiter notebook，Tensorflow ;注册一个AWS用户',
        descriptionEn: 'Example: This course does not require any other prerequisite courses. Software preparation: Integrated development environment download: Intellij / Eclipse; Database download: MySQL & MongoDB; Tool download: Postman, Jupiter notebook, Tensorflow; Register an AWS user',
        intendedFor: '例: 主要针对留学想申请软件工程、计算机应用等方向的学员，通过实战型极强的动手项目，学员会完成大型网站项目的开发，作为申请成果；同时该项目的升级版针对在海外求职中的准从业者，在导师带领下完成工业级别的可拓展、负载均衡、复杂架构设计的软件开发，助力全栈与后端开发岗位的职业申请',
        intendedForEn: 'Example: It is mainly aimed at students who want to apply for software engineering, computer applications and other fields to study abroad. Through a very practical hands-on project, students will complete the development of large-scale website projects as application results; at the same time, the upgraded version of this project is aimed at those who are looking for jobs overseas. As a quasi-practitioner, under the guidance of mentors, we can complete industrial-level scalable, load-balancing, and complex architecture design software development to assist career applications for full-stack and back-end development positions.',
        learnedSkill: '例: 前端后端开发能力',
        learnedSkillEn: 'Example: Front-end and back-end development capabilities',
        willReward: '例: 导师推荐信，课程结业证书',
        willRewardEn: 'Example: Recommendation letter from instructor, course completion certificate',
        outline: '例: 总项目时常为12课时，每周2次，以理论+实践的形式手把手带你搭建一个活动推荐系统',
        outlineEn: 'Example: The total project duration is 12 class hours, twice a week. It takes you step by step to build an activity recommendation system in the form of theory + practice.',
        course: {
          name: '例: Frontend: Introduction to web application, HTML basic, CSS basic, Javascript basic',
          nameEn: 'Example: Frontend: Introduction to web application, HTML basic, CSS basic, Javascript basic',
          inspectionMethod: '例: Web application architecture understanding, Front-end development skill, Interactive page',
          inspectionMethodEn: 'Example: Web application architecture understanding, Front-end development skill, Interactive page',
        },
      },
      message: ['Required field '],
      courseTags: [],
      mentors: [],
      error: {
        nameErrors: [],
        nameEnErrors: [],
        intendedForErrors: [],
        intendedForEnErrors: [],
        projectDurationErrors: [],
        leanedSkillsErrors: [],
        descriptionErrors: [],
        descriptionEnErrors: [],
        outlineErrors: [],
        outlineEnErrors: [],
        sortNumErrors: [],
        statusErrors: [],
      },
      showId: false,
      showUid: false,
      showViews: false,
      showCreateTime: false,
      statusOptions: SERVICE_STATUS_TYPES.map(item => { return item.TEXT }),
      submitButtonStatus: true,
      title: '新增在线项目实战',
      remnant255: '/255',
      remnant400: '/400',
      descriptionRemnantMessage: [],
      descriptionEnRemnantMessage: [],
      outlineRemantMessage: [],
      outlineEnRemantMessage: [],
    }
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.nameEnErrors.length &&
          !this.error.intendedForErrors.length &&
          !this.error.intendedForEnErrors.length &&
          !this.error.projectDurationErrors.length &&
          !this.error.descriptionErrors.length &&
          !this.error.descriptionEnErrors.length &&
          !this.error.outlineErrors.length &&
          !this.error.outlineEnErrors.length &&
          !this.error.statusErrors.length &&
          !this.error.sortNumErrors.length
    },
    computedTags () {
      return this.courseTags.map(x => {
        return x.name
      })
    },
    flipTags () {
      const flipTags = {}
      this.courseTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    computedMentors () {
      return this.mentors.map(x => {
        return x.nickname + '(' + x.uid + ')'
      })
    },
    flipMentors () {
      const flipMentors = {}
      this.mentors.forEach(x => {
        flipMentors[x.nickname + '(' + x.uid + ')'] = x.uid
      })
      return flipMentors
    },
  },
  created () {
    const params = this.$route.params
    if (params.id != null) {
      this.showId = true
      this.title = '编辑在线项目实战'
      this.showUid = true
      this.showViews = true
      this.showCreateTime = true
      // 通过id获取详情
      onlineActionApi.getOnlineAction(params.id).then(response => {
        copyObject(response.onlineAction, this.insertData)
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('courseTags') && response.courseTags.length !== 0) {
          const that = this
          that.insertData.courseTagNames = []
          response.courseTags.forEach(x => {
            that.insertData.courseTagNames.push(x.name)
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('mentors') && response.mentors.length !== 0) {
          const that = this
          that.insertData.mentorUids = []
          response.mentors.forEach(x => {
            that.insertData.mentorUids.push(x.nickname + '(' + x.uid + ')')
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.onlineAction.hasOwnProperty('willRewards') && response.onlineAction.willRewards.length !== 0) {
          const that = this
          this.insertData.willRewards = []
          response.onlineAction.willRewards.forEach(x => {
            that.insertData.willRewards.push({
              reward: x.reward,
              rewardEn: x.rewardEn,
            })
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.onlineAction.hasOwnProperty('learnedSkills') && response.onlineAction.learnedSkills.length !== 0) {
          const that = this
          this.insertData.learnedSkills = []
          response.onlineAction.learnedSkills.forEach(x => {
            that.insertData.learnedSkills.push({
              skill: x.skill,
              skillEn: x.skillEn,
            })
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.onlineAction.hasOwnProperty('status')) {
          SERVICE_STATUS_TYPES.map((item) => {
            if (response.onlineAction.status === item.CODE) {
              this.insertData.status = item.TEXT
            }
          })
        }
        this.insertData.createTime = formatTime(this.insertData.createTime)
        this.descriptionEnDescInput()
        this.descriptionDescInput()
        this.outlineEnDescInput()
        this.outlineDescInput()
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
    this.listCourseTag()
    this.listMentor()
  },
  methods: {
    listCourseTag () {
      tagApi.listTag({ tagType: TAG_TYPE.COURSE_TAG.CODE }).then(response => {
        this.courseTags = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    listMentor () {
      const params = {
        pageNumber: 1,
        pageSize: 1000,
      }
      mentorApi.listMentor(params).then(response => {
        this.mentors = response.mentors
      }).catch(error => {
        console.log(error)
      })
    },
    addReward () {
      this.insertData.willRewards.push({
        id: Math.floor(Math.random() * 100000),
        reward: '',
        rewardEn: '',
      })
    },
    removeReward (reward) {
      this.insertData.willRewards = this.insertData.willRewards.filter(x => x !== reward)
    },
    addSkill () {
      this.insertData.learnedSkills.push({
        id: Math.floor(Math.random() * 100000),
        skill: '',
        skillEn: '',
      })
    },
    removeSkill (skill) {
      this.insertData.learnedSkills = this.insertData.learnedSkills.filter(x => x !== skill)
    },
    addCourse () {
      this.insertData.courses.push({
        id: Math.floor(Math.random() * 100000),
        serial: this.insertData.courses.length + 1,
        name: '',
        nameEn: '',
        inspectionMethod: '',
        inspectionMethodEn: '',
        teachingDuration: 2,
        learningDuration: 2,
      })
    },
    removeCourse (course) {
      this.insertData.courses = this.insertData.courses.filter(x => x !== course)
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      console.log('formReady')
      if (this.insertData.imgUrl.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        serviceId: this.insertData.serviceId,
        imgUrl: this.insertData.imgUrl,
        name: this.insertData.name,
        nameEn: this.insertData.nameEn,
        intendedFor: this.insertData.intendedFor,
        intendedForEn: this.insertData.intendedForEn,
        projectDuration: this.insertData.projectDuration,
        projectDurationEn: this.insertData.projectDurationEn,
        description: this.insertData.description,
        descriptionEn: this.insertData.descriptionEn,
        outline: this.insertData.outline,
        outlineEn: this.insertData.outlineEn,
        views: this.insertData.views,
        courses: this.insertData.courses,
        creatorUid: this.insertData.creatorUid,
        courseTagIds: this.insertData.courseTagNames.map(courseTag => {
          return this.flipTags[courseTag]
        }),
        mentorUids: this.insertData.mentorUids.map(nicknameWithUid => {
          return this.flipMentors[nicknameWithUid]
        }),
        willRewards: this.insertData.willRewards,
        learnedSkills: this.insertData.learnedSkills,
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.status !== null) {
        SERVICE_STATUS_TYPES.map((item) => {
          if (this.insertData.status === item.TEXT) {
            data.status = item.CODE
          }
        })
      }
      if (this.insertData.id !== null) {
        data.id = this.insertData.id
        onlineActionApi.updateOnlineAction(this.insertData.id, data).then(response => {
          if (response.success === true) {
            this.showToast('更新在线实战项目成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listOnlineAction' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        onlineActionApi.saveOnlineAction(data).then(response => {
          if (response.success === true) {
            this.showToast('添加在线实战项目成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listOnlineAction' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {

    },
    uploadOnlineActionImage () {
      if (this.insertData.image.length === 0) return
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData.image[this.insertData.image.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.imgUrl = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.nameEnErrors = this.insertData.nameEn ? [] : ['nameEn is required']
      this.error.intendedForErrors = this.insertData.intendedFor ? [] : ['intendedFor is required']
      this.error.intendedForEnErrors = this.insertData.intendedForEn ? [] : ['intendedForEn is required']
      this.error.projectDurationErrors = this.insertData.projectDuration ? [] : ['projectDuration is required']
      this.error.leanedSkillsErrors = this.insertData.learnedSkills ? [] : ['learnedSkills is required']
      this.error.descriptionErrors = this.insertData.description ? [] : ['description is required']
      this.error.descriptionEnErrors = this.insertData.descriptionEn ? [] : ['descriptionEn is required']
      this.error.outlineErrors = this.insertData.outline ? [] : ['outline is required']
      this.error.outlineEnErrors = this.insertData.outlineEn ? [] : ['outlineEn is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
    },
    descriptionDescInput () { this.descriptionRemnantMessage = [(1024 - this.insertData.description.length).toString() + '/1024'] },
    descriptionEnDescInput () { this.descriptionEnRemnantMessage = [(1024 - this.insertData.descriptionEn.length).toString() + '/1024'] },
    outlineDescInput () { this.outlineRemantMessage = [(1024 - this.insertData.outline.length).toString() + '/1024'] },
    outlineEnDescInput () { this.outlineEnRemantMessage = [(1024 - this.insertData.outlineEn.length).toString() + '/1024'] },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    async translateUnfilledFields () {
      // 课程标题
      if (this.insertData.name !== '' && this.insertData.nameEn === '') {
        this.insertData.nameEn = await translateData(this.insertData.name)
      }
      // 适用人群
      if (this.insertData.intendedFor !== '' && this.insertData.intendedForEn === '') {
        this.insertData.intendedForEn = await translateData(this.insertData.intendedFor)
      }
      // 课程介绍
      if (this.insertData.description !== '' && this.insertData.descriptionEn === '') {
        this.insertData.descriptionEn = await translateData(this.insertData.description)
      }
      // 课程大纲
      if (this.insertData.outline !== '' && this.insertData.outlineEn === '') {
        this.insertData.outlineEn = await translateData(this.insertData.outline)
      }
      // 学习的技能
      await this.translateSkills(this.insertData.learnedSkills)
      // 你将收获
      await this.translateWillRewards(this.insertData.willRewards)
      await this.translateCourses(this.insertData.courses)
    },
    async  translateSkills (skills) {
      const translationPromises = skills.map(async (skill, index) => {
        console.log(`处理技能 ${index}:`, skill)
        if (skill.skill && !skill.skillEn) {
          console.log(`开始翻译技能 ${index}`)
          try {
            skills[index].skillEn = await translateData(skill.skill)
            console.log(`翻译完成: ${skills[index].skillEn}`)
          } catch (error) {
            console.error(`翻译技能 ${index} 时出现错误:`, error)
          }
        } else {
          console.log(`技能 ${index} 不需要翻译或已经翻译`)
        }
      })
      await Promise.all(translationPromises)
      console.log('所有翻译任务已完成')
    },
    async  translateWillRewards (rewards) {
      const translationPromises = rewards.map(async (reward, index) => {
        if (reward.reward && !reward.rewardEn) {
          try {
            rewards[index].rewardEn = await translateData(reward.reward)
          } catch (error) {
            console.error(`翻译技能 ${index} 时出现错误:`, error)
          }
        }
      })
      await Promise.all(translationPromises)
    },
    async  translateCourses (courses) {
      const translationPromises = courses.map(async (course, index) => {
        if (course.name && !course.nameEn) {
          try {
            courses[index].nameEn = await translateData(course.name)
          } catch (error) {
            console.error(`翻译技能 ${index} 时出现错误:`, error)
          }
        }
        if (course.inspectionMethod && !course.inspectionMethodEn) {
          try {
            courses[index].inspectionMethodEn = await translateData(course.inspectionMethod)
          } catch (error) {
            console.error(`翻译技能 ${index} 时出现错误:`, error)
          }
        }
      })
      await Promise.all(translationPromises)
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
